import ModalCreateOrUpdate from "./ModalCreateOrUpdate/ModalCreateOrUpdate.vue";
import HttpMixin from "../../../mixins/HttpMixin";
import UIComponentMixin from "../UIComponentMixin";
import {
  cloneDeep,
  filter,
  some,
} from "lodash-es";

// @vue/component
export default {
  name: "UiDynamischeFeldwertliste",
  components: {
    ModalCreateOrUpdate,
  },
  mixins: [
    HttpMixin,
    UIComponentMixin,
  ],
  props: {
    model: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      dataForFeldDefault: [],
      confirmShow: undefined,
      confirmOptions: undefined,
      statusModal: undefined,
      currentModel: undefined,
      currentIndex: undefined,
    };
  },
  computed: {
    getDataForFeld() {
      return filter(this.dataForFeldDefault, item => {
        if (this.currentModel && this.currentModel.id === item.id) {
          return true;
        }
        return !some(this.model, ["id", item.id]);
      });
    },
  },
  beforeCreate() {
    this.$options.components.Modal = require("../../Modal/Modal.vue").default;
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getListHttp({ url: this.options.url, apiSaveId: this.options.apiSaveId }).then(
        response => {
          this.dataForFeldDefault = response;
          this.loading = false;
        }
      );
    },

    openModalCreate() {
      this.statusModal = true;
    },

    openModalUpdate({ feld, feldIndex }) {
      this.currentModel = feld;
      this.currentIndex = feldIndex;
      this.statusModal = true;
    },

    closeModal({ model } = {}) {
      if (model) {
        this.onInput_mixin({ value: model });
      }
      this.currentModel = undefined;
      this.currentIndex = undefined;
      this.statusModal = false;
    },

    moveUpFeld(index) {
      if (index === 0) {
        return;
      }
      const MODEL = cloneDeep(this.model);

      const ELEM = MODEL[index];
      MODEL.splice(index, 1);
      MODEL.splice(index - 1, 0, ELEM);
      this.onInput_mixin({ value: MODEL });
    },

    moveDownFeld(index) {
      if (index >= this.model.length - 1) {
        return;
      }
      const MODEL = cloneDeep(this.model);
      const ELEM = MODEL[index];
      MODEL.splice(index, 1);
      MODEL.splice(index + 1, 0, ELEM);
      this.onInput_mixin({ value: MODEL });
    },

    openConfirmDelete(index) {
      this.confirmOptions = {
        okClass: "btn btn-primary",
        title: "Feld entfernen",
        msg: "<p>Sind Sie sicher, dass sie das Feld von dieser Regel entfernen wollen?</p>",
        okLabel: "Fortfahren",
        okCallback: () => this.deleteFeld(index),
        cancelCallback: this.closeConfirmDelete,
        loading: false,
      };
      this.confirmShow = true;
    },

    deleteFeld(index) {
      const MODEL = cloneDeep(this.model);
      MODEL.splice(index, 1);
      this.onInput_mixin({ value: MODEL });
      this.closeConfirmDelete();
    },

    closeConfirmDelete() {
      this.confirmShow = false;
    },
  },
};
